import { c as _c } from "react/compiler-runtime";
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
type FormData = {
  authToken: string;
};
const AuthTokenForm = () => {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "signIn.authTokenForm"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t0);
  const {
    logIn
  } = useSession();
  const methods = useForm();
  const {
    handleSubmit,
    formState: t1
  } = methods;
  const {
    isSubmitting
  } = t1;
  let t2;
  if ($[1] !== logIn) {
    t2 = async t3 => {
      const {
        authToken
      } = t3;
      await logIn({
        auth: authToken
      });
    };
    $[1] = logIn;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleFormSubmit = t2;
  let t3;
  if ($[3] !== handleFormSubmit || $[4] !== handleSubmit) {
    t3 = handleSubmit(handleFormSubmit);
    $[3] = handleFormSubmit;
    $[4] = handleSubmit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp2);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = {
      required: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = <Form.Input name="authToken" label={t4} autoComplete="authToken" placeholder={t5} rules={t7} />;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp4);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isSubmitting || $[21] !== t9) {
    t10 = <Button fullWidth={true} size="large" type="submit" loading={isSubmitting}>{t9}</Button>;
    $[20] = isSubmitting;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t3 || $[25] !== t8) {
    t11 = <form className="flex flex-col gap-4" onSubmit={t3}>{t8}{t10}</form>;
    $[23] = t10;
    $[24] = t3;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== methods || $[28] !== t11) {
    t12 = <FormProvider {...methods}>{t11}</FormProvider>;
    $[27] = methods;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
export default AuthTokenForm;
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.placeholder;
}
function _temp3($_1) {
  return $_1.errors.required;
}
function _temp4($_2) {
  return $_2.cta;
}